import Brand from "../brand";
import React from "react";
import {Link} from "react-router-dom";
import policeRegistration from "../../icons/police-registration.png";

export default function DashboardFooter() {
    return (
        <footer className="footer">
            <Brand/>

            <div className="info flex-1">
                <div className="copyright px-2 text-0 font-bold text-sm">&copy; Hoarfroster & Collaborators.
                    All Rights Reserved.
                </div>
            </div>
        </footer>
    );
}